import { render, staticRenderFns } from "./UserInfoModal.vue?vue&type=template&id=59854c0a"
import script from "./UserInfoModal.vue?vue&type=script&lang=js"
export * from "./UserInfoModal.vue?vue&type=script&lang=js"
import style0 from "./UserInfoModal.vue?vue&type=style&index=0&id=59854c0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports